<template>
  <header class="co-hero">
    <div
      class="co-hero__glow"
      aria-hidden="true"
    />
    <div class="co-hero__inner">
      <div class="co-hero__brand">
        <div class="co-hero__logo-wrap">
          <img
            src="@/assets/images/logo/logo.svg"
            alt="ManyConvert"
            class="co-hero__logo"
          >
        </div>
        <div>
          <h1 class="co-hero__title">
            Visão Geral
          </h1>
          <p class="co-hero__subtitle">
            Monitore a central em tempo real e acompanhe o desempenho histórico dos atendimentos.
          </p>
        </div>
      </div>
      <div class="co-hero__actions">
        <b-badge
          pill
          class="co-hero__badge-live"
        >
          <span class="co-hero__pulse" />
          Em tempo real
        </b-badge>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'CentralOperationsHeader',
}
</script>

<style scoped>
.co-hero {
  position: relative;
  border-radius: 24px;
  padding: 2rem 2.25rem;
  overflow: hidden;
  background: linear-gradient(125deg, #4a148c 0%, #7b1fa2 35%, #c2185b 72%, #ff6f61 100%);
  box-shadow: 0 20px 50px rgba(74, 20, 140, 0.35);
}

.co-hero__glow {
  position: absolute;
  inset: -40%;
  background: radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.18) 0%, transparent 45%),
    radial-gradient(circle at 80% 60%, rgba(255, 111, 97, 0.35) 0%, transparent 40%);
  pointer-events: none;
}

.co-hero__inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.75rem;
}

.co-hero__brand {
  display: flex;
  gap: 1.25rem;
  align-items: flex-start;
  max-width: 640px;
}

.co-hero__logo-wrap {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.co-hero__logo {
  width: 100%;
  height: auto;
  filter: brightness(0) invert(1);
}

.co-hero__title {
  margin: 0 0 0.5rem;
  font-size: clamp(1.65rem, 3vw, 2.15rem);
  font-weight: 800;
  color: #fff;
  letter-spacing: -0.02em;
  line-height: 1.15;
}

.co-hero__subtitle {
  margin: 0;
  font-size: 1rem;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.92);
  max-width: 520px;
}

.co-hero__actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 1rem;
}

.co-hero__badge-live {
  background: rgba(255, 255, 255, 0.2) !important;
  color: #fff !important;
  font-weight: 600;
  font-size: 0.8rem;
  padding: 0.45rem 0.9rem;
  border: 1px solid rgba(255, 255, 255, 0.35);
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  align-self: flex-end;
}

.co-hero__pulse {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #7bed9f;
  box-shadow: 0 0 0 0 rgba(123, 237, 159, 0.7);
  animation: co-pulse 2s ease-out infinite;
}

@keyframes co-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(123, 237, 159, 0.5);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(123, 237, 159, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(123, 237, 159, 0);
  }
}

@media (max-width: 768px) {
  .co-hero {
    padding: 1.5rem 1.25rem;
  }

  .co-hero__actions {
    align-items: flex-start;
    width: 100%;
  }
}
</style>
